
import { Vue, Component, Prop, Watch } from "vue-property-decorator";
import t from "@common/src/i18n/t";
import AreaSelect from "../../scope/area-select/index.vue";
import BtnRadio from "../../scope/btn-radio/index.vue";
import dayjs from "dayjs";

@Component({
  components: { AreaSelect, BtnRadio }
})
export default class SbSearchBar extends Vue {
  static componentName = "SbSearchBar";
  t = t;
  @Prop({
    default: () => []
  })
  data: any;

  @Prop({ default: false, type: Boolean })
  defaultExpand: boolean;

  @Prop({
    default: "CN",
    type: String
  })
  countryCode: number;

  @Prop({
    default: 4,
    type: Number
  })
  showItemNum: number;

  @Prop({ default: () => {}, type: Function })
  getAreaMethod: any;

  selfData: any = [];
  openMore: boolean = false;
  total: number = 0;
  copyData: any = [];
  created() {
    if (this.defaultExpand) {
      this.showItemNum = this.data.length;
    }
    if (this.showItemNum < this.data.length) {
      this.openMore = false;
    } else {
      this.openMore = true;
    }
    this.initSelfData(this.data);
  }
  initSelfData(list) {
    this.total = list.length;
    this.copyData = list.slice().filter(item => item.prop);
    let tempArr = [];
    if (this.openMore) {
      tempArr = list.slice();
    } else {
      tempArr = list.slice(0, this.showItemNum);
    }
    // 重新渲染保留旧的value
    if (this.oldData) {
      tempArr = tempArr.map(item => {
        item.value = item.noKeepOld ? item.value : this.oldDataValueMap[item.prop] || item.value;
        return item;
      });
    }
    let num = tempArr.length < 4 ? 4 - tempArr.length : 4 - (tempArr.length % 4);
    while (num > 1) {
      tempArr.push({});
      num--;
    }
    this.selfData = tempArr;
  }
  search() {
    this.$emit("search", this.formatListData());
  }
  reset() {
    this.$emit("reset", this.formatListData(true));
  }
  formatListData(reset = false) {
    const listData = [];
    for (let i = 0; i < this.selfData.length; i++) {
      const itemData = this.selfData[i];
      if (itemData.prop) {
        if (reset) {
          if (itemData.resetValue) {
            itemData.value = this.valueResetter(itemData.value, itemData.resetValue);
          } else if (itemData.required) {
            // 保持不动
          } else {
            itemData.value = this.valueResetter(itemData.value);
            itemData.labels && (itemData.labels = []);
          }
        }
        listData.push(itemData);
        if (itemData.valueDistribute) {
          itemData.valueDistribute.forEach((key, index) => {
            listData.push({
              prop: key,
              value: reset && !itemData.resetValue ? "" : itemData.value?.[index] || ""
            });
          });
        }
      }
    }
    return listData;
  }

  valueResetter(val, resetValue?) {
    // 目前value 只能是 Array 或者 String
    if (Array.isArray(val)) {
      if (resetValue) {
        return [...resetValue];
      } else {
        return [];
      }
    } else {
      if (resetValue) {
        return resetValue;
      } else {
        return "";
      }
    }
  }

  handleMore() {
    this.openMore = !this.openMore;
    this.initSelfData(this.copyData);
  }
  handleAreaChange(val, item) {
    this.$nextTick(() => {
      this.$nextTick(() => {
        const labels = (this.$refs["refAareSelect"] as any)[0].getLabels();
        item.labels = labels;
      });
    });
  }
  oldData: any = null;
  oldDataValueMap: any = {};
  initPropValueMap: any = {};
  @Watch("data", { immediate: true })
  watchData(val, oldVal) {
    if (oldVal) {
      this.oldData = oldVal;
      const map = {};
      oldVal.forEach(item => {
        if (item.prop) {
          map[item.prop] = item.value;
        }
      });
      this.oldDataValueMap = map;
    }
    if (val) {
      const map = {};
      val.forEach(item => {
        if (item.prop) {
          map[item.prop] = item.value;
        }
      });
      this.initPropValueMap = map;
    }
    val && this.initSelfData(val);
  }
  refreshAreaFlag = true;
  @Watch("countryCode")
  watchCountryCode() {
    this.refreshAreaFlag = false;
    this.$nextTick(() => {
      this.refreshAreaFlag = true;
    });
    const areaOption = this.selfData.find(item => item.type === "area");
    areaOption.labels = [];
    areaOption.value = [];
  }
  generateOptionsDate(itemData) {
    return {
      disabledDate: date => {
        if (itemData.disabledFuture) {
          if (itemData.endOffset < 0) {
            return dayjs(date).isAfter(dayjs().subtract(Math.abs(itemData.endOffset), "day").endOf("day"));
          } else if (itemData > 0) {
            return dayjs(date).isAfter(dayjs().add(itemData.endOffset, "day").endOf("day"));
          } else {
            return dayjs(date).isAfter(dayjs().endOf("day"));
          }
        } else {
          return false;
        }
      }
    };
  }
  generateOptionsMonth(itemData) {
    return {
      disabledDate: date => {
        if (itemData.disabledFuture) {
          if (itemData.endOffset < 0) {
            return dayjs(date).isAfter(dayjs().subtract(Math.abs(itemData.endOffset), "month").endOf("month"));
          } else if (itemData.endOffset > 0) {
            return dayjs(date).isAfter(dayjs().add(itemData.endOffset, "month").endOf("month"));
          } else {
            return dayjs(date).isAfter(dayjs().endOf("month"));
          }
        } else {
          return false;
        }
      }
    };
  }
  handleDaterangeChange(itemData) {
    const startDate = dayjs(itemData.value[0]);
    const endDate = dayjs(itemData.value[1]);
    if (itemData.maxDay > 0) {
      const daysDiff = endDate.diff(startDate, "day");
      if (daysDiff > itemData.maxDay) {
        itemData.value = [
          itemData.value[0],
          startDate
            .add(itemData.maxDay, "day")
            .format(itemData.valueFormat ? itemData.valueFormat.toUpperCase() : "YYYYMMDD")
        ];
        return this.$message.error(t("v216_6.date-range-warning", [itemData.maxDay]));
      }
    }
  }
  handleMonthrangeChange(itemData) {
    const startDate = dayjs(itemData.value[0]);
    const endDate = dayjs(itemData.value[1]);
    if (itemData.maxMonth > 0) {
      const daysDiff = endDate.diff(startDate, "month");
      if (daysDiff + 1 > itemData.maxMonth) {
        itemData.value = [
          itemData.value[0],
          startDate
            .add(itemData.maxMonth - 1, "month")
            .format(itemData.valueFormat ? itemData.valueFormat.toUpperCase() : "YYYYMM")
        ];
        return this.$message.error(t("v216_6.month-range-warning", [itemData.maxMonth]));
      }
    }
  }
}
